/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIUserRole } from './APIUserRole';
import {
    APIUserRoleFromJSON,
    APIUserRoleFromJSONTyped,
    APIUserRoleToJSON,
} from './APIUserRole';
import type { APIRootAccount } from './APIRootAccount';
import {
    APIRootAccountFromJSON,
    APIRootAccountFromJSONTyped,
    APIRootAccountToJSON,
} from './APIRootAccount';

/**
 * 
 * @export
 * @interface APIUserSearchResult
 */
export interface APIUserSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIUserSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    guestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    comment?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIUserSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIUserSearchResult
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIUserSearchResult
     */
    isStaff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIUserSearchResult
     */
    isOrgAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIUserSearchResult
     */
    isGuestUser?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    fullName?: string | null;
    /**
     * 
     * @type {APIRootAccount}
     * @memberof APIUserSearchResult
     */
    rootAccount?: APIRootAccount | null;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    rootAccountId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    rootAccountName?: string | null;
    /**
     * 
     * @type {Array<APIUserRole>}
     * @memberof APIUserSearchResult
     */
    roles?: Array<APIUserRole>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIUserSearchResult
     */
    roleIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIUserSearchResult
     */
    roleNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIUserSearchResult
     */
    preferenceLanguage?: string | null;
    /**
     * 
     * @type {number}
     * @memberof APIUserSearchResult
     */
    guestSharepointId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIUserSearchResult
     */
    guestRepForId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIUserSearchResult
     */
    guestTimeToLive?: number | null;
}

/**
 * Check if a given object implements the APIUserSearchResult interface.
 */
export function instanceOfAPIUserSearchResult(value: object): value is APIUserSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIUserSearchResultFromJSON(json: any): APIUserSearchResult {
    return APIUserSearchResultFromJSONTyped(json, false);
}

export function APIUserSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIUserSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'email': json['email'],
        'guestId': json['guest_id'] == null ? undefined : json['guest_id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'isStaff': json['is_staff'] == null ? undefined : json['is_staff'],
        'isOrgAdmin': json['is_org_admin'] == null ? undefined : json['is_org_admin'],
        'isGuestUser': json['is_guest_user'] == null ? undefined : json['is_guest_user'],
        'userType': json['user_type'] == null ? undefined : json['user_type'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'rootAccount': json['root_account'] == null ? undefined : APIRootAccountFromJSON(json['root_account']),
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
        'rootAccountName': json['root_account_name'] == null ? undefined : json['root_account_name'],
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(APIUserRoleFromJSON)),
        'roleIds': json['role_ids'] == null ? undefined : json['role_ids'],
        'roleNames': json['role_names'] == null ? undefined : json['role_names'],
        'preferenceLanguage': json['preference_language'] == null ? undefined : json['preference_language'],
        'guestSharepointId': json['guest_sharepoint_id'] == null ? undefined : json['guest_sharepoint_id'],
        'guestRepForId': json['guest_rep_for_id'] == null ? undefined : json['guest_rep_for_id'],
        'guestTimeToLive': json['guest_time_to_live'] == null ? undefined : json['guest_time_to_live'],
    };
}

export function APIUserSearchResultToJSON(value?: APIUserSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'email': value['email'],
        'guest_id': value['guestId'],
        'comment': value['comment'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'is_active': value['isActive'],
        'is_staff': value['isStaff'],
        'is_org_admin': value['isOrgAdmin'],
        'is_guest_user': value['isGuestUser'],
        'user_type': value['userType'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'full_name': value['fullName'],
        'root_account': APIRootAccountToJSON(value['rootAccount']),
        'root_account_id': value['rootAccountId'],
        'root_account_name': value['rootAccountName'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(APIUserRoleToJSON)),
        'role_ids': value['roleIds'],
        'role_names': value['roleNames'],
        'preference_language': value['preferenceLanguage'],
        'guest_sharepoint_id': value['guestSharepointId'],
        'guest_rep_for_id': value['guestRepForId'],
        'guest_time_to_live': value['guestTimeToLive'],
    };
}

